import React, {Component} from "react";
import DatePicker from 'react-datepicker';
import {getHolidays} from "../../../../helpers";
import sv from 'date-fns/locale/sv';
import { registerLocale } from 'react-datepicker';

registerLocale('sv', sv);

class DateTimeField extends Component {

    constructor(props){
        super(props);
        this.holidaysArray = getHolidays();
    }

    onChange(date){

        if (typeof(this.props.onChange) === "function") {
            this.props.onChange(this.props.id,date);
        }
    }

    handleDateChangeRaw(e){
        e.preventDefault()
    }

    isValidDate(date) {
        // Check if the date is valid
        if (!date) return false;
        if (date === '') return false;
        
        // Try to create a Date object and check if it's valid
        const dateObj = date instanceof Date ? date : new Date(date);
        return dateObj instanceof Date && !isNaN(dateObj.getTime());
    }

    render() {
        const excludedDates = [];
            this.holidaysArray.forEach((date) => {
            excludedDates.push(new Date(date));
        });
        const {id,title,placeholder,value,required} = this.props;

        // Safely handle the value - only use it if it's a valid date
        let selectedDate = null;
        if (this.isValidDate(value)) {
            selectedDate = value instanceof Date ? value : new Date(value);
        }

        return (
            <div key={id} className={"inputFieldWrapper datetimeField"}>
                <label htmlFor={id}>
                    {title}
                </label>
                <div className='datepicker'>
                    <DatePicker
                        name={id}
                        id={id}
                        placeholder={placeholder}
                        selected={selectedDate}
                        onChange={(date)=>this.onChange(date)}
                        dateFormat='yyyy-MM-dd'
                        excludeDates={excludedDates}
                        locale="sv"
                        required={required}
                        autoComplete={"off"}
                        onChangeRaw={(e)=>this.handleDateChangeRaw(e)}
                    />
                </div>
            </div>
        )
    }
}

export default DateTimeField;


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/Form_Elements/DateTimeField.js